import script from "./wuxi.vue?vue&type=script&setup=true&lang=js"
export * from "./wuxi.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__